import { css } from '@emotion/react'
import styles, { mediaQuery, textEllipsis, typo, zIndex } from '@mathflat/common/style'
import colors from '@mathflat/common/style/colors'

const {
  colors: { gray },
} = styles

const S = {
  Wrap: css`
    right: 24px;
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    margin-left: auto;
    padding-left: 30px;

    ${mediaQuery.large} {
      padding-left: 16px;
    }

    .flex {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .handler-button {
      min-width: 40px;
      width: 40px;
      height: 100%;
      border-radius: var(--Radius-100);
      &.clicked {
        background-color: ${colors.gray.$100};
      }
    }

    .icon__wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      border-radius: var(--Radius-200);
      position: relative;

      &:hover {
        background-color: ${colors.gray.$100};
      }

      &.active {
        background-color: ${colors.gray.$200};
        svg {
        }
      }
    }

    .button__notification {
      position: relative;
      border-radius: var(--Radius-200);

      .unread-count {
        position: absolute;
        bottom: 16px;
        left: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1px 4px 0px 4px;
        color: white;
        ${typo.caption02}
        font-weight: 700;
        border: 1px solid white;
        border-radius: var(--Radius-Circle);
        background: rgba(253, 83, 84, 1);

        &.max-count {
          padding: 1px 2px 0px 2px;
        }
      }
    }

    .count-badge {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      border-radius: var(--Radius-100);
      background: var(--Colors-Green-500);
      padding: 1px 4px;
      z-index: 10;
      ${typo.caption02};
      font-weight: 700;
    }

    .noti-badge {
      position: absolute;
      right: -5px;
      top: -5px;
      border: 1px solid white;
    }

    .header__school-exam-zone-badge-container {
      position: relative;
    }
    .feedback-badge {
      display: flex;
      align-items: center;
      padding: 4px;
      cursor: pointer;
    }
  `,
  basic: css`
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;

    .header__profile {
      position: relative;
      display: flex;
      align-items: center;
      gap: 4px;
      height: 33px;
      padding: 6px 12px;
      min-width: 87px;
      border-radius: var(--Radius-200);
      border: 1px solid ${gray.$400} !important;
      color: ${gray.$700};
      margin-left: 8px;

      .profile__chevron-wrapper {
        padding-left: 4px;

        svg {
          transition: transform 0.2s ease-in-out;
        }
      }

      @media (hover: hover) {
        &:hover {
          background-color: var(--Colors-Gray-100);

          .profile__chevron-wrapper {
            svg {
              path {
                fill: var(--Colors-Gray-800);
              }
            }
          }
        }
      }

      &.opened {
        background-color: var(--Colors-Gray-200);

        .profile__chevron-wrapper {
          svg {
            transform: rotate(-180deg);
            path {
              fill: var(--Colors-Gray-800);
            }
          }
        }
      }

      &.active {
        ${typo.body02}
        font-weight: 400;
        background: var(--Colors-Green-50);
        border: 1px solid var(--Colors-Green-500) !important;
        color: var(--Colors-Green-500);

        svg path {
          fill: var(--Colors-Green-500);
        }

        .profile__chevron-wrapper {
          svg {
            path {
              fill: var(--Colors-Green-500);
            }
          }
        }

        .profile__star-icon path {
          fill: white;
        }
      }
      .profile__star-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;

        width: 16px;
        height: 16px;

        border-radius: var(--Radius-Circle);
        background-color: ${colors.subYellow};
      }
      .profile__teacher-nickname {
        line-height: normal;
        font-weight: 400;
      }
    }

    span {
      flex: 1;
      ${textEllipsis(1)};
    }
  `,
  foldingButton: css`
    position: relative;
    display: flex;
    justify-content: center;
    margin: -8px;
    margin-left: 2px;
    padding: 8px;
  `,
  tooltipBanner: (bgUrl: string) => css`
    position: relative;
    display: flex;
    width: 280px;
    height: 83px;
    background: url(${bgUrl}) no-repeat top center;
    background-size: cover;

    .apply-button {
      position: absolute;
      left: 12px;
      bottom: 8px;
      width: 145px;
      height: 30px;
    }
    .clock-area {
      position: absolute;
      top: 18px;
      left: 14px;
      width: 136px;
      height: 21px;
    }
  `,
  tooltipFolding: css`
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    border: 1px solid var(--Colors-Green-200);
    border-radius: var(--Radius-300);
    background-color: var(--Colors-Green-100);
    text-align: left;
    white-space: nowrap;
    z-index: 98;

    &:before {
      content: '';
      position: absolute;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid var(--Colors-Green-100);
      z-index: 1;
    }

    &:after {
      content: '';
      position: absolute;
      border-left: 7px solid transparent;
      border-right: 7px solid transparent;
      border-bottom: 7px solid var(--Colors-Green-200);
    }

    p {
      margin-right: 20px;
    }

    .close-button {
      position: absolute;
      top: 12px;
      right: -2px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 44px;
      height: 74px;
      padding-top: 19px;
      margin-top: -19px;
      padding-bottom: 38px;
      margin-bottom: -38px;
    }
  `,
  textClock: css`
    display: flex;
    ${typo.heading04};
    font-weight: 700;

    .clock-item {
      display: flex;
    }
  `,
  userGuide: css`
    top: 58px;
    right: 12px;
    &:before {
      top: -6px;
      right: 14px;
    }
    &:after {
      top: -7px;
      right: 14px;
    }
  `,
  workbookMallTooltip: css`
    top: 35px;
    left: 0;
    &:before {
      top: -6px;
      left: 20px;
    }
    &:after {
      top: -7px;
      left: 20px;
    }
  `,
}

export default S
